import React from 'react'
import { useLocation } from 'react-router-dom'
import { AuthErrorModal } from './AuthErrorModal/AuthErrorModal'

const AuthErrorPage = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const type = searchParams.get('type')

  return (
    <div>
      {type === 'auth' ? (
        <AuthErrorModal />
      ) : (
        <div>
          <h2>Oops! Something went wrong.</h2>
          <p>Unknown error type.</p>
        </div>
      )}
    </div>
  )
}

export default AuthErrorPage
